/** Nombre visible del proyecto: letras (con tildes), números, espacios, - _ y coma. */
export const INGEST_PROJECT_NAME_MAX_LENGTH = 30;

export const INGEST_PROJECT_NAME_LENGTH_ERROR = `Nombre de carpeta corto: máximo ${INGEST_PROJECT_NAME_MAX_LENGTH} caracteres.`;

export const INGEST_PROJECT_NAME_CHARSET_ERROR = `Solo letras (incluidas tildes), números, guiones (-), guiones bajos (_), comas y espacios (máx. ${INGEST_PROJECT_NAME_MAX_LENGTH}).`;

export const INGEST_PROJECT_NAME_TOOLTIP = `Nombre corto (máx. ${INGEST_PROJECT_NAME_MAX_LENGTH}). Se permiten letras con tildes, números, espacios, -, _ y comas. La carpeta física se genera sin tildes.`;

/** Base ASCII permitida tras quitar marcas diacríticas (NFD). */
const INGEST_PROJECT_NAME_BASE_PATTERN = /^[A-Za-z0-9\s_,-]+$/;

/**
 * Valida sin `\p{L}` (puede fallar según transpilación del bundle).
 * Acepta tildes vía NFD: quita marcas y exige solo ASCII permitido en la base.
 */
export function validateIngestProjectName(name: string | undefined | null): string | null {
  const trimmed = name?.trim() ?? '';
  if (!trimmed) {
    return 'El nombre es obligatorio.';
  }
  if (trimmed.length > INGEST_PROJECT_NAME_MAX_LENGTH) {
    return INGEST_PROJECT_NAME_LENGTH_ERROR;
  }

  const baseAscii = trimmed.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  if (!INGEST_PROJECT_NAME_BASE_PATTERN.test(baseAscii)) {
    return INGEST_PROJECT_NAME_CHARSET_ERROR;
  }
  return null;
}

/**
 * Carpeta física ASCII (sin tildes) para create.
 * El nombre visible puede llevar tildes; el path del FS / POST suele ser más estricto.
 */
export function toIngestProjectFolderPath(name: string): string {
  const ascii = name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^A-Za-z0-9\s_-]/g, '')
    .trim()
    .replace(/\s+/g, '_')
    .slice(0, INGEST_PROJECT_NAME_MAX_LENGTH);
  return ascii || 'proyecto';
}

/** Nombre ASCII seguro para POST (el display con tildes se aplica luego con PUT). */
export function toIngestProjectCreateName(name: string): string {
  return toIngestProjectFolderPath(name);
}

export function ingestProjectNameNeedsPutAfterCreate(displayName: string): boolean {
  const trimmed = displayName.trim();
  return trimmed.length > 0 && trimmed !== toIngestProjectCreateName(trimmed);
}
